"use client";

import React from "react";
import type { TGalleryFilterContext } from "../types";

const GalleryFilterContext = React.createContext<TGalleryFilterContext>({
  selectedTags: new Set(),
  toggleTag: () => {},
});

export default GalleryFilterContext;
